module.exports = __webpack_public_path__ + "static/media/dynamic-floor-plan-icon.7d5bdd91.svg";